import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Note } from "../../../../Pages/TableEditor/SettingsMenu/General/LimitRows/LimitRows";
import Flex from "../../../../UI/Flex/Flex";
import IOButton from "../../../../UI/Form/Button/IOButton";
import Checkbox from "../../../../UI/Form/Checkbox/Checkbox";
import Input from "../../../../UI/Form/Input/Input";
import { useState } from "react";

export default function SettingsNewItem({
  group,
  setGroup,
  saveNewGroup,
  loading,
  getFiltersForSave,
  dropDates,
}) {
  const isSelected = getFiltersForSave().length;
  const disabled = !group.name || !isSelected;

  const [showWarning, setShowWarning] = useState(false);

  const handleSave = () => {
    setShowWarning(disabled);

    if (!disabled) {
      saveNewGroup();
    }
  };

  return (
    <div>
      <Flex
        style={{ marginBottom: 20 }}
        alignItems="center"
        justifyContent="space-between"
      >
        <Input
          placeholder="Name your settings"
          style={{ width: "50%" }}
          value={group.name ?? ""}
          onChange={(e) => setGroup({ ...group, name: e.target.value })}
        />
        <Flex>
          <Checkbox
            label="Make Default"
            onChange={() => setGroup({ ...group, isDefault: !group.isDefault })}
            checked={!!group.isDefault}
          />

          <IOButton
            smallPadding
            style={{ width: 80, fontSize: 12, marginLeft: 5 }}
            onClick={dropDates}
            title="Return Dates to default state from Site Configuration"
          >
            Reset&nbsp;Dates
          </IOButton>

          <IOButton
            smallPadding
            style={{ width: 80, fontSize: 12, marginLeft: 5 }}
            onClick={handleSave}
            processing={loading}
          >
            Save
          </IOButton>
        </Flex>
      </Flex>
      {showWarning ? (
        <Note color="warningDark">
          {!group.name ? (
            <div>
              Please enter a name before saving the new settings group.
              <FontAwesomeIcon icon={["fas", "exclamation-triangle"]} />
            </div>
          ) : null}
          {!isSelected ? (
            <div>
              Please select at least one filter before saving the new settings
              group.
              <FontAwesomeIcon icon={["fas", "exclamation-triangle"]} />
            </div>
          ) : null}
        </Note>
      ) : null}
    </div>
  );
}
